
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skipasy",
      function () {
        return require("private-next-pages/[region]/[resort]/skipasy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skipasy"])
      });
    }
  